/**
 * Mock automation / journey data. Each flow is a sequence of typed `steps`
 * the visual builder renders as a vertical node graph. Wire to backend later.
 */
export const AUTOMATION_STATUS = {
  active: { tone: "success", label: "Active" },
  paused: { tone: "high",    label: "Paused" },
  draft:  { tone: "neutral", label: "Draft" },
};

/** Node visual config per step type. */
export const STEP_TYPES = {
  trigger:   { label: "Trigger",   color: "var(--color-primary)",   bg: "var(--color-primary-tint)" },
  email:     { label: "Email",     color: "var(--color-info)",      bg: "var(--color-info-bg)" },
  wait:      { label: "Wait",      color: "var(--color-warning)",   bg: "var(--color-warning-bg)" },
  condition: { label: "Condition", color: "var(--color-secondary)", bg: "var(--color-secondary-tint)" },
  goal:      { label: "Goal",      color: "var(--color-success)",   bg: "var(--color-success-bg)" },
};

export const AUTOMATIONS = [
  {
    id: "auto_01",
    name: "Welcome Series",
    status: "active",
    trigger: "Contact subscribes",
    goal: "Activate new signups",
    enrolled: 3200,
    active: 412,
    completed: 2614,
    convRate: 22.4,
    revenue: 18600,
    updatedAt: "Jun 26, 2026",
    steps: [
      { type: "trigger",   label: "Subscribes to list", detail: "Entry trigger" },
      { type: "email",     label: "Welcome to SwiftReach", detail: "Sent immediately · 67% open" },
      { type: "wait",      label: "Wait 2 days", detail: "Delay" },
      { type: "email",     label: "How estimating works", detail: "52% open · 14% click" },
      { type: "condition", label: "Opened last email?", detail: "Branch on engagement" },
      { type: "email",     label: "Book a demo", detail: "41% open · 9% click" },
      { type: "goal",      label: "Requested a demo", detail: "Conversion goal" },
    ],
  },
  {
    id: "auto_02",
    name: "Win-back Dormant Leads",
    status: "active",
    trigger: "No activity in 90 days",
    goal: "Re-engage dormant contacts",
    enrolled: 12400,
    active: 1840,
    completed: 9100,
    convRate: 8.7,
    revenue: 9400,
    updatedAt: "Jun 22, 2026",
    steps: [
      { type: "trigger",   label: "Inactive 90 days", detail: "Entry trigger" },
      { type: "email",     label: "We miss you 👋", detail: "29% open" },
      { type: "wait",      label: "Wait 3 days", detail: "Delay" },
      { type: "condition", label: "Opened?", detail: "Branch" },
      { type: "email",     label: "Here's 20% off", detail: "Incentive · 24% open" },
      { type: "goal",      label: "Placed an order", detail: "Conversion goal" },
    ],
  },
  {
    id: "auto_03",
    name: "Abandoned Estimate Follow-up",
    status: "active",
    trigger: "Started but didn't submit estimate",
    goal: "Recover incomplete estimates",
    enrolled: 5400,
    active: 320,
    completed: 4800,
    convRate: 31.2,
    revenue: 27300,
    updatedAt: "Jun 19, 2026",
    steps: [
      { type: "trigger",   label: "Estimate abandoned", detail: "Entry trigger" },
      { type: "wait",      label: "Wait 1 hour", detail: "Delay" },
      { type: "email",     label: "Finish your estimate", detail: "58% open · 22% click" },
      { type: "wait",      label: "Wait 1 day", detail: "Delay" },
      { type: "email",     label: "Need help? Talk to us", detail: "44% open" },
      { type: "goal",      label: "Estimate submitted", detail: "Conversion goal" },
    ],
  },
  {
    id: "auto_04",
    name: "Post-Purchase Nurture",
    status: "paused",
    trigger: "Completes first order",
    goal: "Drive repeat business",
    enrolled: 1820,
    active: 0,
    completed: 1820,
    convRate: 16.5,
    revenue: 12100,
    updatedAt: "Jun 10, 2026",
    steps: [
      { type: "trigger", label: "First order placed", detail: "Entry trigger" },
      { type: "email",   label: "Thank you + tips", detail: "61% open" },
      { type: "wait",    label: "Wait 7 days", detail: "Delay" },
      { type: "email",   label: "Refer a colleague", detail: "Referral ask" },
      { type: "goal",    label: "Second order", detail: "Conversion goal" },
    ],
  },
  {
    id: "auto_05",
    name: "Lead Scoring Drip",
    status: "draft",
    trigger: "Lead score reaches 50",
    goal: "Push warm leads to sales",
    enrolled: 0,
    active: 0,
    completed: 0,
    convRate: 0,
    revenue: 0,
    updatedAt: "Jun 04, 2026",
    steps: [
      { type: "trigger",   label: "Score ≥ 50", detail: "Entry trigger" },
      { type: "email",     label: "Case study", detail: "Not sent yet" },
      { type: "condition", label: "Clicked link?", detail: "Branch" },
      { type: "goal",      label: "Sales accepted", detail: "Conversion goal" },
    ],
  },
];

/** Pre-built starter recipes shown at the top of the page. */
export const AUTOMATION_STARTERS = [
  { id: "s1", name: "Welcome new subscribers", desc: "Greet & onboard every new signup automatically.", icon: "👋", tone: "primary" },
  { id: "s2", name: "Win back inactive leads", desc: "Re-engage contacts who've gone quiet for 90 days.", icon: "🔁", tone: "high" },
  { id: "s3", name: "Recover abandoned estimates", desc: "Follow up when an estimate is left incomplete.", icon: "📝", tone: "info" },
  { id: "s4", name: "Post-purchase nurture", desc: "Turn first-time buyers into repeat clients.", icon: "💎", tone: "success" },
];

export const AUTOMATION_KPIS = [
  { key: "flows",   label: "Active Flows",     value: "3",      change: "+1",     up: true },
  { key: "enrolled",label: "Contacts Enrolled",value: "22.8K",  change: "+9.4%",  up: true },
  { key: "conv",    label: "Avg Conversion",   value: "17.2%",  change: "+2.3%",  up: true },
  { key: "revenue", label: "Attributed Revenue",value: "$67.4K", change: "+14%",  up: true },
];
